module.exports = __webpack_public_path__ + "static/img/bottom-banner.effd5440.png";